module.exports = __webpack_public_path__ + "static/media/error.c5e82c34.jpg";